import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router'
import { Stack, SimpleTabs, SimpleBreadcrumbs } from '@/components/lib'

import Responses from './Responses'
import HardwareResponses from './HardwareResponses'
import ParticipantFoodDiaries from './FoodDiaries'
import Information from './Information'
import Consent from './Consent'
import Timeline from './Timeline'
import Meetings from './Meetings'
import Incentives from './Incentives'
import CasebookSignature from './CasebookSignature'

import api from '../../../api'
import utils from '../../../utils/utils'
import useStore from '../../../store'
import useTitle from '../../../hooks/useTitle'

export default function Participant () {
  const { id, participantId } = useParams()
  const [participant, setParticipant] = useState()
  // Bumped when the casebook is signed, so the Responses tab refetches its
  // signatures rather than showing the responses as still unsigned.
  const [signaturesVersion, setSignaturesVersion] = useState(0)
  const { user, trial } = useStore()
  useTitle(participant?.id || 'Participant', trial)

  useEffect(() => {
    api.participants.get(id, participantId, setParticipant)
  }, [participantId])

  const tabs = [
    {
      title: 'Information',
      to: `/trials/${trial._id}/participants/${participantId}/information`,
      content: <Information trialId={id} participantId={participantId} participant={participant} setParticipant={setParticipant} />
    },
    {
      title: 'Responses',
      to: `/trials/${trial._id}/participants/${participantId}/responses`,
      content: <Responses trialId={id} participantId={participantId} refreshKey={signaturesVersion} />
    },
    ...(trial.foodDiariesEnabled
      ? [{
          title: 'Food diaries',
          to: `/trials/${trial._id}/participants/${participantId}/food-diaries`,
          content: <ParticipantFoodDiaries trialId={id} participantId={participantId} />
        }]
      : []),
    {
      title: 'Wearable responses',
      to: `/trials/${trial._id}/participants/${participantId}/wearable-responses`,
      content: <HardwareResponses trialId={id} participantId={participantId} />
    },
    {
      title: 'Timeline',
      to: `/trials/${trial._id}/participants/${participantId}/timeline`,
      content: <Timeline trialId={id} participantId={participantId} participant={participant} />
    }
  ]
  if (utils.canReadParticipantConsent(user, trial)) {
    tabs.push({
      title: 'Consent',
      to: `/trials/${trial._id}/participants/${participantId}/consent`,
      content: <Consent trialId={id} participantId={participantId} participant={participant} />
    })
  }
  if (utils.canReadParticipantMeetings(user, trial)) {
    tabs.push({
      title: 'Meetings',
      to: `/trials/${trial._id}/participants/${participantId}/meetings`,
      content: <Meetings trialId={id} participantId={participantId} participant={participant} />
    })
  }
  tabs.push({
    title: 'Incentives',
    to: `/trials/${trial._id}/participants/${participantId}/incentives`,
    content: <Incentives trialId={id} participantId={participantId} />
  })

  return (
    <Stack gap={5}>
      <SimpleBreadcrumbs items={[
        { label: 'Participants', to: `/trials/${trial._id}/participants` },
        { label: participant?.id || 'participant', to: `/trials/${trial._id}/participants/${participantId}` }
      ]}
      />
      <CasebookSignature trialId={id} participantId={participantId} onSigned={() => setSignaturesVersion(v => v + 1)} />
      <SimpleTabs lazyMount tabs={tabs} />
    </Stack>
  )
}
